import { RootState } from '../models';

export const selectCurrentSceneId = (state: RootState) => state.context.currentSceneIndex;